import axios from 'axios';

export default {
  state: {
    favorite: [],
    loading: false,
    error: null,
    favoriteLoaded: false
  },
  mutations: {
    SET_FAVORITE(state, product) {
      state.favorite = product;
      state.favoriteLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_FAVORITE_LOADING(state, status) {
      state.favoriteLoading = status;
    },
    SET_FAVORITE_ERROR(state, error) {
      state.favoriteError = error;
    },
    UNSET_FAVORITE(state) {
      state.favoriteLoaded = false;
      state.favoriteLoading = false;
      state.favorite = [];
    },
  },
  actions: {
    async fetchFavorite({ commit, state }, id) {
      // Проверяем, были ли категории уже загружены
      if (state.loaded && state.product) {
        //return; // Если данные уже загружены, прекращаем выполнение
      }

      try {
        commit('SET_FAVORITE_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/catalog/favorite/');
        commit('SET_FAVORITE', response.data.data);
        commit('SET_FAVORITE_ERROR', null);
      } catch (error) {
        commit('SET_FAVORITE_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching product:', error);
      } finally {
        commit('SET_FAVORITE_LOADING', false);
      }
    }
  },
  getters: {
    favorite: state => state.favorite,
    favoriteLoading: state => state.favoriteLoading,
    favoriteError: state => state.favoriteError,
    favoriteLoaded: state => state.favoriteLoaded
  }
}